module.exports = __webpack_public_path__ + "static/media/SegoeUI.6581cfae.ttf";